import {
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  StatusBar,
} from "react-native";
import React, { useEffect } from "react";
import { showSuccess } from "@/utils/toast";
import useUserStore from "@/store/user";
import * as Clipboard from "expo-clipboard";
import { LinearGradient } from "expo-linear-gradient";
import { FontFamilies } from "@/constants/Typography";
import Header from "@/components/ui/Header";
import Constants from "expo-constants";
import FBTrackingService from "@/services/fbTrackingService";

const ReferScreen = () => {
  const { userProfile } = useUserStore();
  const link = `https://usesparrow.onelink.me/h5cL/iamwg19q?deep_link_value=${userProfile?.id}`;

  const handleCopyLink = () => {
    Clipboard.setStringAsync(link);
    showSuccess("Link copied to clipboard");
  };

  useEffect(() => {
    FBTrackingService.trackViewContent("referral");
  }, []);

  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" />
      <LinearGradient colors={["#26913B", "#243D3C"]} style={styles.gradient}>
        <View style={styles.content}>
          <Header backColor="white" backgroundColor="transparent" />
          {/* Close Button */}
          <View style={styles.content}>
            <View style={styles.mainContent}>
              {/* Main Content */}
              <Text style={styles.mainTitle}>
                Invite a friend and{"\n"}you’ll both file free
              </Text>

              <Text style={styles.subtitle}>
                You have {userProfile?.userCredits} free claims remaining.{"\n"}
                Invite a friend to get 1 free.
              </Text>
            </View>

            {/* Link Sharing Section */}
            <View style={styles.linkContainer}>
              <Text style={styles.linkInput} numberOfLines={1}>
                {link}
              </Text>
              <TouchableOpacity
                style={styles.copyButton}
                onPress={handleCopyLink}
              >
                <Text style={styles.copyButtonText}>Copy link</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </LinearGradient>
    </View>
  );
};

export default ReferScreen;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  gradient: {
    flex: 1,
  },
  content: {
    flex: 1,
    paddingTop: Constants.statusBarHeight,
    paddingHorizontal: 16,
    justifyContent: "center",
  },
  mainContent: {
    alignItems: "center",
    marginBottom: 40,
    marginTop: -120,
  },
  mainTitle: {
    fontSize: 30,
    fontFamily: FontFamilies.InterTight.Medium,
    color: "white",
    textAlign: "center",
    marginBottom: 20,
    lineHeight: 40,
  },
  subtitle: {
    fontSize: 15,
    fontFamily: FontFamilies.Inter.Regular,
    color: "#FFFFFF",
    textAlign: "center",
    lineHeight: 24,
  },
  linkContainer: {
    flexDirection: "row",
    backgroundColor: "white",
    borderRadius: 12,
    padding: 8,
    alignItems: "center",
  },
  linkInput: {
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 12,
    fontSize: 16,
    color: "#666",
  },
  copyButton: {
    backgroundColor: "#0F9129",
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 20,
  },
  copyButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
  },
});
